import { httpClient } from '@/shared/api/httpClient';
import { Profile } from '@/shared/types/certificate-request';

/** Nome não entra aqui — vem do login (gov.br) e é travado no backend. */
export interface PersonalDataInput {
  motherName?: string;
  birthDate?: string;
  socialName?: string;
}

export interface ContactInput {
  email: string;
  phone?: string;
}

export const profileApi = {
  async get(): Promise<Profile> {
    const { data } = await httpClient.get<Profile>('/profile');
    return data;
  },

  async savePersonalData(input: PersonalDataInput): Promise<Profile> {
    const { data } = await httpClient.put<Profile>('/profile', input);
    return data;
  },

  async saveContact(input: ContactInput): Promise<Profile> {
    const { data } = await httpClient.put<Profile>('/profile/contact', input);
    return data;
  },
};
